import React,{Component} from 'react';
import {connect} from "react-redux";
import "./style.less";
import {passengerInfo,changeAddress} from "../../../service/shiftService";
import {fakeConverse} from "../../../service/homeService";
import {NavBar,Toast,Button,Modal} from "antd-mobile";
import moment from 'moment';
const black = require('../../../common/image/black.png');
//出发地点
var porpStartAddressPoint = '';//全局数据，用于保存地址选择后的数据，经纬度
var porpStartAddress = '';//全局数据，用于保存地址选择后的数据，
//目的地
var porpEndAddressPoint = '';//全局数据，用于保存地址选择后的数据，经纬度
var porpEndAddress = '';//全局数据，用于保存地址选择后的数据，
var endCityName,endStationId;//到达起止点名字，到达起止点的id
var lastSeatId = '';//上一次选中的出行位置id
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class PassengerInfo extends Component{
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            startDate:'',
            showModal:false,
            showModal2:false,
            amount:'',
            endCity:'',
            startCity:'',
            seatNum:'',
            startTime:'',
            weekend:'',
            passengerName:'',
            intercityPhone:'',
            phone:'',
            shunt:[],
            isChild:'',
            startPlace:porpStartAddress ? porpStartAddress : '',
            endPlace:porpEndAddress ? porpEndAddress : '',
            startShuntStatus:'',
            endShuntStatus:'',
            btnstatus:0,
            startPoint:'',//出发起止点经纬度
            endStation:[],//到达起止点数组
            endPoint:'',
            startPointName:'',//出发起止点具体位置
            endPointName:'',//到达起止点具体位置
            orderId:'',
            canFlag:true,
            isEndorse:'',//0是正常订单，1是改签订单，2是特殊改签
            seatId:this.props.location.state.seatId,
            endStationId:'',
            lineId:'',
            startStationId:'',
        };
        this._returnAddressResult = this._returnAddressResult.bind(this);
        this._toChooseAddress = this._toChooseAddress.bind(this);
    }
    componentDidMount() {
        setTimeout(() => {
            if(this.props.location.state.timestamp  > this.props.location.state.startCurrentTimeMillis){
                this.setState({
                canFlag:false,
                })
            };
        }, 0);
       this.getPassengerInfo();
        
        
    }
    //获取乘客详情
    getPassengerInfo = () =>{
        let params = {
            token: this.props.userInfo.token,
            "data": {
                "seatId":this.props.location.state.seatId
            }
        };
        passengerInfo(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    let data = res.data.data
                    this.setState({
                        startDate:data.startDate,
                        startTime:data.startTime,
                        weekend:data.weekend,
                        amount:data.amount,
                        endCity:data.endCity,
                        startCity:data.startCity,
                        seatNum:data.seatNum,
                        passengerName:data.passengerName,
                        intercityPhone:data.intercityPhone,
                        phone:data.phone,
                        shunt:data.shunt,
                        startPoint:data.shunt[0].position.split('_').reverse().join(),
                        startPointName:data.shunt[0].address,
                        endPoint:data.shunt[1].position.split('_').reverse().join(),
                        endPointName:data.shunt[1].address,
                        orderId:data.id,
                        isEndorse:data.isEndorse,
                        endStationId:data.endStationId,
                        lineId:data.lineId,
                        startStationId:data.startStationId,
                        isChild:data.isChild
                    })
                    this.setState({
                        startPlace:this.state.shunt[0].address,
                        endPlace:this.state.shunt[1].address,
                        startShuntStatus:this.state.shunt[0].shuntStatus,
                        endShuntStatus:this.state.shunt[1].shuntStatus,
                    })
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
    }
    shunt =(e)=>{
        if(e === 0){
            return "未处理"
        }
        if(e === 1){
            return "已分流报单"
        }
        if(e === 2){
            return "不分流报单"
        }
    };
     /**
     * 地址选择页面返回数据
     * @param {object} result 
     */
    _returnAddressResult(result){
        console.log('_returnAddressResult',result)
        var datas = result;
        if(result.type === 'pay'){
            datas = result.datas;
        }
        //判断是否支付成功
        // if(datas.paySuccess){

        // }
        let address = datas.address;
        console.log(datas)
        switch (datas.type) {
            case 'start':
                if(typeof(datas.point)==="string"){
                    let startBackPoint = datas.point.split(',')
                    
                    porpStartAddressPoint = startBackPoint[1] + '_' +startBackPoint[0] ;
                }else{
                    let startBackPoint = datas.point;
                    porpStartAddressPoint = startBackPoint.lat + '_' + startBackPoint.lng;
                }
                porpStartAddress = address;
                if(datas.shunt && datas.shunt.length > 0){
                    datas.shunt.forEach(d => {
                        if(d.type == 2){
                            porpStartAddressPoint = d.position;
                            porpStartAddress = d.address;
                        }
                    });
                }
                break;
            case 'end':
                if(datas.point.length){
                    let endBackPoint = datas.point;
                    porpEndAddressPoint = endBackPoint[1] + '_' + endBackPoint[0];
                }else{
                    let endBackPoint = datas.point;
                    porpEndAddressPoint = endBackPoint.lat + '_' + endBackPoint.lng;
                }
                porpEndAddress = address;
                endCityName = datas.endCity;
                endStationId = datas.endStationId;
                if(datas.shunt && datas.shunt.length > 0){
                    datas.shunt.forEach(d => {
                        if(d.type == 2){
                            porpEndAddressPoint = d.position;
                            porpEndAddress = d.address;
                        }
                    });
                }
                break;
        }
    }
    /**
     * 跳转到地址选择页面
     * 
     * @param {string} type 
     */
    _toChooseAddress(type){
        this.getPassengerInfo();
        //当前地址是否存在状态为支付中且来源为司机的订单,是：弹窗提示司机正在修改地址；否:当前地址是否存在状态为支付中且来源为当前调度人员的订单=>  是：跳转扫码支付页面，获取地址修改订单信息及支付二维码；否：跳转地址选择页面；
        let params ={
            token: this.props.userInfo.token,
            "data": {
                "intercityOrderId":this.state.orderId,
                "operatorType":1
            }
        }
        changeAddress(params).then((res) => {
            console.log(res)
            if (res.data.code === '0000') {//返回成功，且没有数据，就跳转到地址选择页面，返回如果有二维码和金额就跳转到二维码支付码支付界面
            // if (true) {//返回成功，且没有数据，就跳转到地址选择页面，返回如果有二维码和金额就跳转到二维码支付码支付界面
                if(res.data.data === null){
                    var datas = {type:type,returnData:this._returnAddressResult.bind(this)};
                    var historyData = {
                        pathname:'/ChangeAddress',
                    };
                    if(type === 'start'){
                        datas.address = this.state.startAddress;
                        historyData.startCity=this.state.startCity;
                        historyData.startPoint=this.state.startPoint;
                        historyData.startPointName=this.state.startPointName;
                        historyData.orderId=this.state.orderId;
                        historyData.seatId=this.state.seatId;

                    }else if(type === 'end'){
                        datas.address = this.state.endAddress;
                        historyData.endCity=this.state.endCity;
                        historyData.endPoint=this.state.endPoint;
                        historyData.startPointName=this.state.endPointName;
                        historyData.orderId=this.state.orderId;
                        historyData.seatId=this.state.seatId;

                    }
                    datas.returnData = this._returnAddressResult.bind(this);
                    historyData.datas = datas;
                    this.props.history.push(historyData)
                }else if(res.data.data.addresschangeId){
                    let timestamp = (new Date()).getTime();//获取当前时间戳
                    let addresschangeTime = moment(res.data.data.addresschangeTime).valueOf();//订单生成的时间
                    let timeArea = moment(addresschangeTime).add(600, 'seconds').format('x') - timestamp;//订单剩余支付秒数
                    var data = this.state;
                    if(!res.data || !res.data.data){
                        Toast.fail('数据不存在');
                        return;
                    }
                    if(type === 'start'){
                        data.address = this.state.startAddress;
                        data.startCity=this.state.startCity;
                        data.startPoint=this.state.startPoint;
                        data.startPointName=this.state.startPointName;

                    }else if(type === 'end'){
                        data.address = this.state.endAddress;
                        data.endCity=this.state.endCity;
                        data.endPoint=this.state.endPoint;
                        data.startPointName=this.state.endPointName;
                    }
                    data.orderId=this.state.orderId;
                    data.image = res.data.data.imgPath;
                    data.amount = res.data.data.spreadPrice;
                    data.addresschangeId = res.data.data.addresschangeId;
                    data.addressChangeAfter = res.data.data.addressChangeAfter;
                    data.addressChangeBefore = res.data.data.addressChangeBefore;
                    data.returnData = this._returnAddressResult.bind(this);
                    data.timeArea = timeArea;
                    data.type = type;
                    var historyData = {
                        pathname:'/TwoDimensionalCode',
                        data:data,
                        historyType:"change",
                        seatId:this.state.seatId
                    };
                    Toast.info('该订单存在未支付金额，请先支付金额！',2, this.props.history.push(historyData))
                }
            }
            else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
        }).catch(function (error) {
            console.log(error);
        });
        
    }
    selectShift = () => {
        this.props.history.push('/SelectShift',
        {
            startCity:this.state.startCity,
            endCity:this.state.endCity,
            startPosition:this.state.startPoint.split(',').reverse().join('_'),
            endPosition:this.state.endPoint.split(',').reverse().join('_'),
            id:this.state.orderId,//需要订单id
            startAddress:this.state.startPlace,
            endAddress:this.state.endPoint,
            "lineIds": [
                {
                    "endStationId": this.state.endStationId,
                    "lineId": this.state.lineId,
                    "startStationId": this.state.startStationId
                }
            ]    
        })
    }
    refundTicket = () => {
            this.props.history.push('/refundTicket',{id:this.state.orderId,refundType:1})
    }
    callPhone =()=>{
        this.setState({
            showModal2:true
        })
        
    }
    number=()=>{ 
        let params = {
            token: this.props.userInfo.token,
            "data": {
                "id": this.state.orderId,
                orderSource:6,
            }
        };
        fakeConverse(params).then((res) => {
            console.log(res)
            if (res.data.code === '0000') {
                window.location.href = "tel://" +  res.data.data.middleNumber;
            }
            else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
        }).catch(function (error) {
            console.log(error);
        });
    }
    render(){
        return(
            <div className="passengerInfo">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >乘客详情</NavBar>
                <div className="content">
                {this.state.isEndorse === 1 ? <div className="change">改签订单</div> :this.state.isEndorse === 2 ? <div className="special">特殊改签订单</div>: null }
                    <div className="topDiv">
                        <div className="body">
                            <div>{this.state.startCity}</div>
                            <div>
                                <div>{this.state.startDate} {this.state.weekend} {this.state.startTime}</div>
                                <img src={black}/>
                            </div>
                            <div>{this.state.endCity}</div>
                        </div>
                        <p>当前出行位置<span>{this.state.seatNum}号</span></p>
                    </div>
                    <div className="middle">
                        <div className="left">
                            <i className="icon iconfont icondaixiadanchufadi"/>
                            <div className="circleCon"></div>
                            <i className="icon iconfont icondaixiadanmudedi"/>
                        </div>
                        <div className="right">
                             <div className="text">
                               <div className="">
                                    <p className="address">{this.state.startPlace}</p>
                                    <p className="status">分流状态：<span>{this.shunt(this.state.startShuntStatus)}</span></p>
                                </div>
                                <Button 
                                    disabled={this.state.startShuntStatus !== 0} 
                                    className={this.state.startShuntStatus !== 0 ? "borderStyle":""} 
                                    onClick={this._toChooseAddress.bind(this,'start')}
                                >修改</Button>
                            </div>
                            <div className="text">
                                <div className="">
                                    <p className="address">{this.state.endPlace}</p>
                                    <p className="status">分流状态：<span>{this.shunt(this.state.endShuntStatus)}</span></p>
                                </div>
                                <Button 
                                    disabled={this.state.endShuntStatus !== 0} 
                                    className={this.state.endShuntStatus !== 0 ? "borderStyle":""} 
                                    onClick={this._toChooseAddress.bind(this,'end')}
                                >修改</Button> 
                            </div>
                        </div>
                    </div>
                    <div className="bottom">
                        <div className="oldOrder">
                            <span className="tit">乘客类型</span>
                            <span className="child">{this.state.isChild == 1 ? '儿童订单' : '普通乘客'}</span>
                        </div>
                        <div className="oldOrder">
                            <span className="tit">乘客姓名</span>
                            <span>{this.state.passengerName}</span>
                        </div>
                        <div className="oldOrder">
                            <span className="tit">联系电话</span>
                            <span className="color" onClick={()=>this.callPhone()}>{this.state.intercityPhone}</span>
                        </div>
                        <div className="oldOrder">
                            <span className="tit">支付金额</span>
                            <span>￥{this.state.amount}</span>
                        </div>
                    </div>
                    <Modal
                        className="combineBillViewModal"
                        visible={this.state.showModal2}
                        transparent
                        maskClosable={false}
                        footer={[{ text: '否', onPress: () => { this.setState({showModal2:!this.state.showModal2}); } },{ text: '是', onPress: () => { this.setState({showModal2:!this.state.showModal2});this.number() } }]}
                    >
                        <div className="modalTitle">
                            <div>是否确认拨打电话？</div>
                         {/*    <span>出于隐私保护，该号码为虚拟号码</span> */}
                        </div>
                    </Modal>
                    <Modal
                        className="billViewModal"
                        visible={this.state.showModal}
                        transparent
                        maskClosable={false}
                        footer={[{ text: '知道了', onPress: () => { this.setState({showModal:!this.state.showModal}); } }]}
                    >
                        <div className="modalTitle">
                            <div className="default">司机端正在修改此地址</div>
                            <div>为避免重复修改，请稍后再试</div>
                        </div>
                    </Modal>
                </div>
                {this.state.canFlag === false || this.props.history.location.state.owner === 0 ? null :
                    this.props.history.location.state.status === 12 ? (<div className="btnGroup">
                        <button className="btn1" onClick={()=>this.selectShift()}>改签</button>
                        <button className="btn2" onClick={()=>this.refundTicket()}>退票</button>
                    </div>) :null
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/PassengerInfo/index.js